// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"c0f70819","305":"411761aa","5672":"411761aa","7286":"411761aa","7390":"a631fae3","7493":"54c83451"}[chunkId] + ".chunk.css";
};